<template>
  <Dashboard :title="$t('account.team_invite.layout_title')">
    <div class="flex justify-center my-10">
      <div class="bg-white shadow sm:rounded-md">
        <div class="px-4 py-5 sm:p-6">
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            {{ $t('account.team_invite.invited_by', { inviter: teamInvite?.user?.email || $t('account.team_invite.someone'), team: teamInvite?.team?.name || $t('account.team_invite.a_team') }) }}
          </h3>
          <div class="mt-2 sm:flex sm:items-start sm:justify-between">
            <div class="max-w-xl text-sm text-gray-500">
              <p>
                {{ $t('account.team_invite.join_consequence', { team: teamInvite?.team?.name || $t('account.team_invite.this_team') }) }} <br />
                {{ $t('account.team_invite.demos_not_copied') }}
              </p>
            </div>
            <div class="mt-5 sm:mt-0 sm:ml-6 sm:flex sm:flex-shrink-0 sm:items-center">
              <button
                type="button"
                @click="acceptInvite"
                class="inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
              >
                {{ $t('account.team_invite.accept') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Dashboard>
</template>

<script>
import axios from 'axios';
import { mapMutations, mapState } from 'vuex';
import Dashboard from '../components/layouts/DashboardLayout.vue';

export default {
  components: { Dashboard },
  head() {
    return { title: this.$t('account.team_invite.page_title') };
  },
  data: function data() {
    return {
      token: '',
      inviteStatus: '',
      teamInviteId: '',
      teamInvite: {},
      load: false,
    };
  },
  computed: {
    ...mapState(['activeTeam']),
    user() {
      return this.$auth.user() || {};
    },
    teamName() {
      return this.team.name || 'My Team';
    },
    team() {
      // Checks to see which team to display based on activeTeamId
      for (let i = 0; i < this.user.teams.length; i++) {
        if (this.user.teams[i].id === Number(localStorage.activeTeamId)) {
          return this.user.teams[i];
        }
      }
      return this.user.teams[0] || {};
    },
  },
  mounted() {
    this.token = this.$route.params.token;
    this.getTeamInvite();
  },
  methods: {
    ...mapMutations(['showMessage', 'hideMessage']),
    getTeamInvite() {
      axios
        .get(`/team_invites/${this.token}`)
        .then((response) => {
          if (response.data.email.toLowerCase() === this.user.email.toLowerCase()) {
            this.teamInvite = response.data;
            this.load = true;
          } else {
            this.$router.push('/');
          }
        })
        .catch((error) => {
          this.$router.push('/');
        });
    },
    acceptInvite() {
      // Adds user to team and changes page to that team page or dashboard
      axios({
        url: `/team_invites/${this.token}/accept`,
        method: 'POST',
      })
        .then(() => {
          this.showMessage({ messageType: 'success', messageText: this.$t('account.team_invite.accepted') });
          this.$auth.fetch();
          this.$router.push('/');
        })
        .catch((err) => {
          this.showMessage({
            messageType: 'error',
            messageText: this.$t('account.team_invite.accept_failed'),
          });
        });
    },
  },
};
</script>
